import { Tab } from "@blueprintjs/core";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { TitreDiplomeCertificationApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { useQuery } from "react-query";
import { TitreDiplomeCertificationDetailPage } from "./TitreDiplomeCertificationDetailPage";

interface ITitreDiplomeCertificationItemPageProps {}

export const TitreDiplomeCertificationItemPage: React.FunctionComponent<ITitreDiplomeCertificationItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const idTitreDiplomeCertification = React.useMemo(() => +id, [id]);
  const history = useHistory();

  const diplomeApi = useApiService(TitreDiplomeCertificationApi);
  const { data: displayName } = useQuery(["titre-cd-display-name", id], () =>
    diplomeApi.titreDiplomeCertificationGetDisplayName({ id: +id })
  );

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.TitreDiplomeCertifications), route: ERoutes.titreDiplomeCertification },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsTitreDiplomeCertification"
        onChange={newTabId => history.push(`${ERoutes.titreDiplomeCertification}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.titreDiplomeCertification}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={
            <TitreDiplomeCertificationDetailPage
              idTitreDiplomeCertification={idTitreDiplomeCertification}
              editMode={state === "edit"}
            />
          }
        />
      </ProtectedTabs>
    </PageBase>
  );
};
